import { useFormContext } from 'react-hook-form';

export interface FormFieldConfig {
    name: string;
    label: string;
    type: 'text' | 'number' | 'select' | 'checkbox';
    placeholder?: string;
    options?: { label: string; value: string }[];
    defaultValue?: any;
    validation?: {
        required?: boolean;
        min?: number;
        max?: number;
        minLength?: number;
        maxLength?: number;
        pattern?: RegExp;
        validate?: (value: any) => boolean | string;
    };
}

export const useFormField = () => {
    const formContext = useFormContext();
    
    // Return null values if form context is not available
    if (!formContext) {
        return {
            registerField: () => ({
                control: null,
                name: '',
                rules: {},
                error: null,
                errorMessage: '',
                value: '',
                onChange: () => {},
            }),
            control: null,
            errors: {},
            watch: () => '',
            setValue: () => {},
        };
    }

    const { control, formState: { errors }, watch, setValue } = formContext;

    const registerField = (config: FormFieldConfig) => {
        const fieldError = errors[config.name];
        
        return {
            control,
            name: config.name,
            rules: config.validation ? {
                required: config.validation.required ? `${config.label} is required` : false,
                min: config.validation.min ? { value: config.validation.min, message: `${config.label} must be at least ${config.validation.min}` } : undefined,
                max: config.validation.max ? { value: config.validation.max, message: `${config.label} must be at most ${config.validation.max}` } : undefined,
                minLength: config.validation.minLength ? { value: config.validation.minLength, message: `${config.label} must be at least ${config.validation.minLength} characters` } : undefined,
                maxLength: config.validation.maxLength ? { value: config.validation.maxLength, message: `${config.label} must be at most ${config.validation.maxLength} characters` } : undefined,
                pattern: config.validation.pattern ? { value: config.validation.pattern, message: `${config.label} format is invalid` } : undefined,
                validate: config.validation.validate,
            } : {},
            error: fieldError,
            errorMessage: fieldError?.message as string,
            value: watch(config.name),
            onChange: (value: any) => setValue(config.name, value),
        };
    };

    return {
        registerField,
        control,
        errors,
        watch,
        setValue,
    };
}; 